<ng-container *ngIf="sortedModules">
    <ng-container *ngFor="let module of sortedModules">
        <cna-module-tile
            [learningModuleInfo]="module"
            [courseType]="courseType"
            [mayAccessLearning]="mayAccessLearning"
            (selectModule)="navigateToModule($event)"
            (printModule)="onPrintModule($event)"
        ></cna-module-tile>
    </ng-container>
    <div
        class="placeholder"
        *ngIf="
            sortedModules.length % 2 !== 0 &&
            sortedModules.length > 1
        "
    ></div>
</ng-container>
